export default __webpack_public_path__ + "static/media/linkedIn-icon.679c53c6.svg";